import { success } from "toastr";
import {
  FETCH_CATEGORIES,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  DELETE_CATEGORY,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE 
} from "./actionTypes";

const initialState = {
  categories: [],
  loading: false,
  error: null,
  success:false
};

const categoriesReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_CATEGORIES:
      return { ...state, loading: true };
    case FETCH_CATEGORIES_SUCCESS:
      return { ...state, loading: false, categories: action.payload.data};
    case FETCH_CATEGORIES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_CATEGORY_REQUEST:
      return { ...state, loading: true, success:false, error: null };
    
    case CREATE_CATEGORY_SUCCESS:
      return { ...state, loading: false, success:true, categoryData: action.payload, error: null };

    case CREATE_CATEGORY_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    case DELETE_CATEGORY:
      return { ...state, loading: true, success:false, error: null }; // Clear previous errors
    
    case DELETE_CATEGORY_SUCCESS:
      return { ...state, loading: false, success:true, deleteResponse: action.payload, error: null };
    
    case DELETE_CATEGORY_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };
      
  
    default:
      return state;
  }
};

export default categoriesReducer;
